/**
 * AP-8 — FM-WIN-05: gemeinsames Detailfenster `Field`/`Value`.
 * Wird sowohl vom DM1-Monitor als auch vom Address-Claim-Monitor benutzt
 * (Dm1DetailWindow wird im Original von beiden mitbenutzt) und aktualisiert
 * sich nicht selbst — es zeigt den Stand des Doppelklicks.
 */

import './viewsB.css';
import { createDataTable } from './dataTable';
import { createFloatingPanel, type FloatingPanel } from './filters/FloatingPanel';

export interface DetailField {
  label: string;
  value: string;
}

let panel: FloatingPanel | null = null;
let titleElement: HTMLElement | null = null;
let table: ReturnType<typeof createDataTable> | null = null;

function ensurePanel(): void {
  if (panel !== null) return;
  panel = createFloatingPanel('Detail');
  panel.element.classList.add('cm-panel-window--medium');
  // FloatingPanel legt den Titel als erstes <span> in seinen Kopf — der Titel
  // dieses Fensters wechselt je Auswahl ("DM1 Detail - SA 00" / "NAME Detail").
  titleElement = panel.element.querySelector('.cm-panel-window__header span');
  table = createDataTable({ columns: ['Field', 'Value'], emptyText: 'no data' });
  panel.body.append(table.element);
}

export function showDetailFields(title: string, fields: readonly DetailField[]): void {
  ensurePanel();
  if (titleElement !== null) titleElement.textContent = title;
  table?.setRows(fields.map((field) => [field.label, field.value]));
  panel?.show();
}

export function hideDetailFields(): void {
  panel?.hide();
}
